import { render, staticRenderFns } from "./PhonePasswordLogin.vue?vue&type=template&id=778f7b80"
import script from "./PhonePasswordLogin.vue?vue&type=script&lang=js"
export * from "./PhonePasswordLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports